export default class Sliders {
  constructor() {
    $('.callout__slider').slick({
      adaptiveHeight: true,
      dots: true
    });
  }
}
